import * as Cookies from "../util/cookie.util";

/**
 * Created by Administrator on 2017/7/17.
 */
//用户名
var cache = {
  dataReady: false,
  token: "",
  userInfo: { name: "", key: "", thirdPartyDealerCode: "", dealerCode:"", loginName:"", userType:"" },
  menus: [],
};
cache.token = localStorage.getItem("token") || "";

export const setUserInfo = (info, thirdPartyDealerCode, area,loginName, dealerCode, userType) => {
  cache.dataReady = true;
  cache.userInfo.name = info;
  cache.userInfo.thirdPartyDealerCode = thirdPartyDealerCode;
  cache.userInfo.area = area || "";
  cache.userInfo.loginName = loginName || "";
  cache.userInfo.dealerCode = dealerCode || "";
  cache.userInfo.userType = userType || "";
};

export const getUserInfo = () => {
  return cache.userInfo;
};

export const setMenus = (info) => {
  cache.dataReady = true;
  cache.menus = info;
};

export const getToken = () => {
  return cache.token;
};

export const setToken = (token, needPersistence = false) => {
  cache.token = token;
  if (needPersistence) {
    localStorage.setItem("token", token);
    Cookies.setCookie("da-token", token, true);
  } else {
    localStorage.setItem("token", token);
    Cookies.setCookie("da-token", token, false);
  }
};



// WEBPACK FOOTER //
// ./src/base/temp-cache.js